var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProcess05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.279 13.6875H17.3047C16.9017 13.6875 16.5893 14.0397 16.6375 14.4398L20.375 45.4768C20.4157 45.8144 20.7021 46.0684 21.0422 46.0684H72.1732C72.5022 46.0684 72.7829 45.8302 72.8363 45.5055L77.9421 14.4686C78.0094 14.0594 77.6937 13.6875 77.279 13.6875Z",
    stroke: "#222222",
    strokeWidth: 3.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78467 6.40039H15.3323L20.9989 55.7813H71.5941",
    stroke: "#222222",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4991,
    cy: 67.1138,
    r: 5.68571,
    stroke: "#222222",
    strokeWidth: 3.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.4512,
    cy: 67.1138,
    r: 5.68571,
    stroke: "#222222",
    strokeWidth: 3.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcess05);
export default __webpack_public_path__ + "static/media/icon_process_05.16a820898f99378ce26b3ff9abadbe1f.svg";
export { ForwardRef as ReactComponent };